import { render, staticRenderFns } from "./ProjectPlannedResourcesResponsibleAndSubscribersWrap.vue?vue&type=template&id=08cc5682&"
import script from "./ProjectPlannedResourcesResponsibleAndSubscribersWrap.vue?vue&type=script&lang=js&"
export * from "./ProjectPlannedResourcesResponsibleAndSubscribersWrap.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports